export class BankingDataDetails {
    bankName: string;
    address: object;
    currency: object;
    bicSwiftCode: string;
    bankKey: string;
    keySortCode: string;
    accountNumber: string;
    iban: string;
    accountHolderName: string;
}


// WEBPACK FOOTER //
// ./src/app/agora/components/account-data/banking-data/details/banking-data-details.model.ts